<div class="right-side p-5">
  <form [formGroup]="totalmsmeform">
    <h2>Total MsMe Registration Details</h2>
    <div class="row">
      <div class="text-end">
        <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">Export to Excel</button>
      </div>
      <div class="col-lg-7 col-sm-12">
        <div class="search-container">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(totalmsmeform.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
        <div *ngIf="totalmsmeform.get('searchControl')?.invalid && (totalmsmeform.get('searchControl')?.touched || totalmsmeform.get('searchControl')?.dirty)">
          <small *ngIf="totalmsmeform.get('searchControl')?.errors?.['pattern']" class="text-danger">
            Invalid search term.
          </small>
        </div>
      </div>

      <div class="section">
        <div class="report-container">



          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="eventName" matSort matSortDirection="desc" matSortDisableClear>
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
              </ng-container>

             
              <ng-container matColumnDef="udyamRegistrationNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Number</th>
                <td mat-cell *matCellDef="let el"> {{ el.udyamRegistrationNumber }} </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let el"> {{el.email}} </td>
              </ng-container>

              <ng-container matColumnDef="nameOfEnterprise">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of Enterprise </th>
                <td mat-cell *matCellDef="let el"> {{el.nameOfEnterprise}} </td>
              </ng-container>
              
              <ng-container matColumnDef="ownersMobileNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                <td mat-cell *matCellDef="let el"> {{ el.ownersMobileNumber }} </td>
              </ng-container>
             

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!--Row shown when there is no matching data.-->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="5">No data matching the filter</td>

              </tr>
            </table>

          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>


        </div>
      </div>
    </div>
  </form>
</div>
